module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00021-fs8.a71f3fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00021-fs8.png
// module id = 174
// module chunks = 0